import { render } from "./AddClaimItemComponent.vue?vue&type=template&id=6fe38246&scoped=true"
import script from "./AddClaimItemComponent.vue?vue&type=script&lang=js"
export * from "./AddClaimItemComponent.vue?vue&type=script&lang=js"

import "./AddClaimItemComponent.vue?vue&type=style&index=0&id=6fe38246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe38246"]])

export default __exports__